module.exports = __webpack_public_path__ + "img/Time.e1dcad09.svg";